/**
 * Studio Navigation Configuration
 * Editorial nav for the existing designer routes (no new modules)
 */

import type { LucideIcon } from "lucide-react";
import {
	Calculator,
	FileText,
	FolderKanban,
	Hammer,
	Home,
	ImageIcon,
	Layers,
	Settings,
} from "lucide-react";

export interface StudioNavItem {
	label: string;
	path: string;
	icon: LucideIcon;
	badge?: number;
}

export interface StudioNavGroup {
	label?: string;
	items: StudioNavItem[];
}

export const STUDIO_NAV: StudioNavGroup[] = [
	{
		label: "STUDIO",
		items: [
			{ label: "Home", path: "/dashboard", icon: Home },
			{ label: "Requests", path: "/requests", icon: FileText },
			{ label: "Projects", path: "/projects", icon: FolderKanban },
			{ label: "Estimates & BOQ", path: "/boqs", icon: Calculator },
			{ label: "Contractors", path: "/contractors", icon: Hammer },
		],
	},
	{
		label: "LIBRARY",
		items: [
			{ label: "Portfolio", path: "/portfolio", icon: ImageIcon },
			{ label: "Catalog", path: "/catalog", icon: Layers },
		],
	},
];

export const SECONDARY_NAV: StudioNavItem[] = [
	{ label: "Settings", path: "/settings", icon: Settings },
];
